module.exports = __webpack_public_path__ + "kubernetes-e8db181e11928ffdb046bc89f750dd06.svg";